//React & npms
import { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

//MUI
import Grid from '@mui/material/Grid2';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
// import Drawer from '@mui/material/Drawer';
// import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

//Icons
// import MenuIcon from '@mui/icons-material/Menu';

//Our Imports 
import { imageExist } from '../js/init';
import { useLenis } from '../../ScrollLenisProvider';


const Header = () => {

	const lenis = useLenis();

	const theme    = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md')); 

	const [angle, setAngle] = useState(0);
	// const [drawerOpen, setDrawerOpen] = useState(false);

	useEffect(() => {
		let animationFrame;
		// Start the animation after 5 seconds
		const timer = setTimeout(() => {
			const animate = () => {
				setAngle(prev => (prev + 1) % 360);
				animationFrame = requestAnimationFrame(animate);
			};
			animate();
		}, 1000);
	
		return () => {
			clearTimeout(timer);
			cancelAnimationFrame(animationFrame);
		};
	}, []);

	const scrollToSection = (e, link) => {
		e.preventDefault(); // stop default anchor jump

		if (!lenis) return;

		lenis.scrollTo(`${link}`, {
			duration: 3,
			easing: (t) => 1 - Math.pow(1 - t, 4)
		});
		// setDrawerOpen(false);
	};

	//Header Menu List
	const menuList = [
		{
			menu: 'Benefits',
			link: '#benefits'
		},
		{
			menu: 'About',
			link: '#about'
		},
		{
			menu: 'Contact',
			link: '#contact'
		}
	];

	// const toggleDrawer = () => {
	// 	setDrawerOpen(!drawerOpen);
	// };

	return (
		<Box className='mblHeader' sx={{ bgcolor: '#fbfaf8', zIndex: 5, position: 'relative' }}> 
			<Container className='containerFull'>
				<Grid container justifyContent={{ md:'space-between', sm:'space-between', xs:'space-between' }} alignItems='center' py={{ md: '25px', xs: '10px' }}>
					{/* Logo  */}
					<Grid size={{ md: 3, sm: 3, xs: 12 }}>
						<Stack spacing={2} direction='row' alignItems='center' justifyContent={{ xs: 'center', md: 'flex-start' }}>
							{/* {isMobile && 
								<IconButton onClick={toggleDrawer}>
									<MenuIcon className='font25 primaryCl'/>
								</IconButton>
							} */}
							<Box className='displayCenter' sx={{ gap: '10px' }}>
								{imageExist({
									required  : '/logo',
									url       : '/logo.svg',
									alt       : 'logo',
									height    : isMobile ? '25px' : '45px'
								})}
								{imageExist({
									required  : '/logo',
									url       : '/text.svg',
									alt       : 'logo',
									height    : isMobile ? '15px' : '25px'
								})}
							</Box>
						</Stack>
					</Grid>
					{/* Nav Links  */}
					<Grid className='headerNav'>
						<Stack direction='row' justifyContent='space-between' spacing={6} className='headerMenu'>
							{menuList.map((list, key)=>(
								// <Link to={list.link} key={i} className='menu'>{list.menu}</Link>
								<Typography key={key} className='font16 textCl fontBolder cursorPointer navOption' onClick={(e) => scrollToSection(e, list.link)}>{list.menu}</Typography>
							))}
						</Stack>
					</Grid>
					{/* App Link Button */}
					<Grid size={{ md: 3, sm: 4, xs: 6 }} sx={{ textAlign: 'right' }} className='hideInMbl'>
						<Box
							sx={{
								position: 'relative',
								display: 'inline-block',
								borderRadius: '50px',
								backgroundColor: 'var(--cafsPurple)',
								padding: '2px',
								'& :hover': {
									cursor: 'pointer'
								},
								'&::before': {
									content: '""',
									position: 'absolute',
									top: '-5px',
									left: '-5px',
									right: '-5px',
									bottom: '-5px',
									borderRadius: '50px',
									filter: 'blur(10px)',
									zIndex: 0,
									background: `conic-gradient(from ${angle}deg at 52.5% 50%, #A066C9 0deg, #BA89D8 86deg, #E0C6F2 170deg, #FFF0B3 232deg, #FFD84D 277deg, #A066C9 360deg)`
								},
								'& > span': {
									position: 'relative',
									zIndex: 1,
									display: 'inline-block',
									backgroundColor: 'var(--cafsPurple)',
									// border: '2px solid rgba(255, 255, 255, 0)',
									backdropFilter: 'blur(1.8px)',
									color: 'white',
									padding: '12px 30px',
									borderRadius: '50px',
									fontSize: '20px',
									fontWeight: 1000
								}
							}}
						>
							<span>Get The App</span>
						</Box>
					</Grid>
				</Grid>
			</Container>
			{/* <Drawer
				anchor='left'
				open={drawerOpen}
				onClose={toggleDrawer}
			>
				<Stack spacing={3} sx={{ width: '100px' }} pt={5} px={2} className='headerMenu'>
					{menuList.map((list,i)=>(
						<Typography key={i} className='font16 textCl fontBolder cursorPointer' onClick={(e) => scrollToSection(e, list.link)}>{list.menu}</Typography>
					))}
				</Stack>
			</Drawer> */}
		</Box>
	);
};

export default Header;
